module.exports = __webpack_public_path__ + "img/north-korea.bb9ff242.png";